export default __webpack_public_path__ + "assets/audios/15d9bebca5b0b33f5c94124bafdb9b8c.mp3";